var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("loading", {
        attrs: { active: _vm.isLoading, loader: "dots" },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _vm.logicTestForm === null
        ? _c(
            "div",
            { staticClass: "validate-wrap" },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "text-align": "center",
                    "background-color": "#cbdafc",
                    "border-radius": "25px",
                    padding: "5px",
                    width: "125px",
                    margin: "0 auto",
                    "margin-bottom": "30px",
                  },
                },
                [_vm._v("邏輯考試")]
              ),
              _c("img", {
                attrs: { src: require("@/assets/img/工作區域 7.png"), alt: "" },
              }),
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: "請選擇人員" },
                  model: {
                    value: _vm.currentPerson.Guid,
                    callback: function ($$v) {
                      _vm.$set(_vm.currentPerson, "Guid", $$v)
                    },
                    expression: "currentPerson.Guid",
                  },
                },
                _vm._l(_vm.personList, function (person) {
                  return _c("el-option", {
                    key: person.Value,
                    attrs: { label: person.Text, value: person.Value },
                  })
                }),
                1
              ),
              _c("el-input", {
                staticStyle: { width: "100%" },
                attrs: { placeholder: "請輸入身分證字號" },
                model: {
                  value: _vm.currentPerson.IdNo,
                  callback: function ($$v) {
                    _vm.$set(_vm.currentPerson, "IdNo", $$v)
                  },
                  expression: "currentPerson.IdNo",
                },
              }),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.validatePerson },
                },
                [_vm._v("確認")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.logicTestForm !== null && _vm.completed === false
        ? _c(
            "el-form",
            {
              ref: "logicTestForm",
              staticClass: "feedback-form",
              attrs: { model: _vm.logicTestForm },
            },
            [
              _c("div", { staticClass: "form-title" }, [_vm._v("邏輯考試")]),
              _c(
                "div",
                { staticClass: "text-center" },
                [
                  !_vm.writing
                    ? _c(
                        "el-button",
                        {
                          staticClass: "mb-2",
                          attrs: { type: "primary", disabled: _vm.writing },
                          on: {
                            click: function ($event) {
                              _vm.writing = true
                            },
                          },
                        },
                        [_vm._v("開始填寫")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "table",
                [
                  _c("tr", [
                    _c(
                      "th",
                      {
                        staticClass: "text-center",
                        attrs: { scope: "row", rowspan: "3" },
                      },
                      [_vm._v("基本資料")]
                    ),
                    _c("th", { attrs: { scope: "row" } }, [_vm._v("姓名")]),
                    _c(
                      "td",
                      [
                        _c(
                          "el-form-item",
                          [
                            _c("el-input", {
                              attrs: { disabled: true },
                              model: {
                                value: _vm.logicTestForm.Arrange.Name,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.logicTestForm.Arrange,
                                    "Name",
                                    $$v
                                  )
                                },
                                expression: "logicTestForm.Arrange.Name",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("tr", [
                    _c("th", { attrs: { scope: "row" } }, [_vm._v("Email")]),
                    _c(
                      "td",
                      [
                        _c(
                          "el-form-item",
                          [
                            _c("el-input", {
                              attrs: { disabled: true },
                              model: {
                                value: _vm.logicTestForm.Arrange.Email,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.logicTestForm.Arrange,
                                    "Email",
                                    $$v
                                  )
                                },
                                expression: "logicTestForm.Arrange.Email",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("tr", [
                    _c("th", { attrs: { scope: "row" } }, [_vm._v("手機號碼")]),
                    _c(
                      "td",
                      [
                        _c(
                          "el-form-item",
                          [
                            _c("el-input", {
                              attrs: { disabled: true },
                              model: {
                                value: _vm.logicTestForm.Arrange.Phone,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.logicTestForm.Arrange,
                                    "Phone",
                                    $$v
                                  )
                                },
                                expression: "logicTestForm.Arrange.Phone",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._l(
                    _vm.logicTestForm.Questions,
                    function (question, index) {
                      return [
                        _c("tr", { key: question.Guid }, [
                          _c("td", { attrs: { colspan: "2" } }, [
                            _vm._v(" " + _vm._s(question.Title)),
                            _c("br"),
                            _c("img", {
                              attrs: {
                                src: question.FileDetailBase64,
                                alt: "",
                              },
                            }),
                          ]),
                          _c(
                            "td",
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop: "Questions." + index + ".Value",
                                    rules: [
                                      {
                                        required: true,
                                        message: "必填",
                                      },
                                    ],
                                  },
                                },
                                [
                                  question.InputType === 1
                                    ? _c(
                                        "el-select",
                                        {
                                          attrs: { disabled: !_vm.writing },
                                          model: {
                                            value: question.Value,
                                            callback: function ($$v) {
                                              _vm.$set(question, "Value", $$v)
                                            },
                                            expression: "question.Value",
                                          },
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: { value: true, label: "是" },
                                          }),
                                          _c("el-option", {
                                            attrs: {
                                              value: false,
                                              label: "否",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  question.InputType === 2
                                    ? _c("el-input", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          type: "number",
                                          disabled: !_vm.writing,
                                        },
                                        model: {
                                          value: question.Value,
                                          callback: function ($$v) {
                                            _vm.$set(question, "Value", $$v)
                                          },
                                          expression: "question.Value",
                                        },
                                      })
                                    : _vm._e(),
                                  question.InputType === 3
                                    ? _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: { disabled: !_vm.writing },
                                          model: {
                                            value: question.Value,
                                            callback: function ($$v) {
                                              _vm.$set(question, "Value", $$v)
                                            },
                                            expression: "question.Value",
                                          },
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: { value: "A" },
                                          }),
                                          _c("el-option", {
                                            attrs: { value: "B" },
                                          }),
                                          _c("el-option", {
                                            attrs: { value: "C" },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  question.InputType === 4
                                    ? _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: { disabled: !_vm.writing },
                                          model: {
                                            value: question.Value,
                                            callback: function ($$v) {
                                              _vm.$set(question, "Value", $$v)
                                            },
                                            expression: "question.Value",
                                          },
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: { value: "A" },
                                          }),
                                          _c("el-option", {
                                            attrs: { value: "B" },
                                          }),
                                          _c("el-option", {
                                            attrs: { value: "C" },
                                          }),
                                          _c("el-option", {
                                            attrs: { value: "D" },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  question.InputType === 5
                                    ? _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: { disabled: !_vm.writing },
                                          model: {
                                            value: question.Value,
                                            callback: function ($$v) {
                                              _vm.$set(question, "Value", $$v)
                                            },
                                            expression: "question.Value",
                                          },
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: { value: "A" },
                                          }),
                                          _c("el-option", {
                                            attrs: { value: "B" },
                                          }),
                                          _c("el-option", {
                                            attrs: { value: "C" },
                                          }),
                                          _c("el-option", {
                                            attrs: { value: "D" },
                                          }),
                                          _c("el-option", {
                                            attrs: { value: "E" },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  question.InputType === 6
                                    ? _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: { disabled: !_vm.writing },
                                          model: {
                                            value: question.Value,
                                            callback: function ($$v) {
                                              _vm.$set(question, "Value", $$v)
                                            },
                                            expression: "question.Value",
                                          },
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: { value: "A" },
                                          }),
                                          _c("el-option", {
                                            attrs: { value: "B" },
                                          }),
                                          _c("el-option", {
                                            attrs: { value: "C" },
                                          }),
                                          _c("el-option", {
                                            attrs: { value: "D" },
                                          }),
                                          _c("el-option", {
                                            attrs: { value: "E" },
                                          }),
                                          _c("el-option", {
                                            attrs: { value: "F" },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  question.InputType === 9
                                    ? _c("el-input", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          type: "text",
                                          disabled: !_vm.writing,
                                        },
                                        model: {
                                          value: question.Value,
                                          callback: function ($$v) {
                                            _vm.$set(question, "Value", $$v)
                                          },
                                          expression: "question.Value",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    }
                  ),
                ],
                2
              ),
              _c(
                "div",
                { staticClass: "text-center" },
                [
                  _vm.writing
                    ? _c(
                        "el-button",
                        {
                          staticStyle: { "margin-top": "10px" },
                          attrs: { type: "primary", round: "" },
                          on: {
                            click: function ($event) {
                              return _vm.submitForm("logicTestForm")
                            },
                          },
                        },
                        [_vm._v("送出")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm.completed
        ? _c(
            "div",
            { staticClass: "complete-wrap" },
            [
              _c("img", {
                attrs: {
                  src: require("@/assets/img/complete_02.png"),
                  alt: "",
                },
              }),
              _c("div", { staticClass: "text" }, [_vm._v("測驗已送出")]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.goLogin } },
                [_vm._v("離 開")]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: { title: "提示", visible: _vm.dialogVisible, width: "30%" },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("span", [_vm._v("確實填寫完成?")]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.sendFeedback } },
                [_vm._v("確 認")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }